import { ApplicationConfig, inject, Injector, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { TokenInterceptor } from './common/interceptors/token/token.interceptor';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { httpLoaderFactory } from './templates/mcs-c2p/mcs-c2p.module';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideZonelessChangeDetection(),
        provideHttpClient(
            withInterceptors([(req, next) => {
                const injector = inject(Injector);
                const interceptor = injector.get(TokenInterceptor);
                return interceptor.intercept(req, { handle: next });
            }])
        ),
        importProvidersFrom(
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: TranslateHttpLoader,
                    deps: [HttpClient]
                }
            })
        ),
        TokenInterceptor,
        provideRouter(routes), provideClientHydration(withEventReplay())
    ]
};